import './Queries.scss';

import { useEffect, useState } from 'react';

import SideBar from '../../components/SideBar/SideBar';
import TopNav from '../../components/TopNav/TopNav';
import UserQueries from './UserQueries/UserQueries';
import VenueQueries from './VenueQueries/VenueQueries';

import {Tab, TabsContainer} from '../../utils/tab';

const Queries = () => {
    const [userQueries, setUserQueries] = useState(true);
    const [venueQueries, setVenueQueries] = useState(false);


    useEffect(() => {
        const savedTab = localStorage.getItem("queriesSelectedTab");
        if (savedTab === "userQueries") {
            setUserQueries(true);
            setVenueQueries(false);
        } else {
            setUserQueries(false);
            setVenueQueries(true);
        }
    }, []);

    function handleSubNavClick(tab) {
        switch (tab) {
            case "userQueries":
                setVenueQueries(false);
                setUserQueries(true);
                localStorage.setItem("queriesSelectedTab", "userQueries");

                break;
            case "venueQueries":
                setUserQueries(false);
                setVenueQueries(true);
                localStorage.setItem("queriesSelectedTab", "venueQueries");

                break;
            default:
                break;
        }
    }
    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />

                <article className="page-content">
                    <section className="events">
                        <div className="events__top">
                            <h1 className="events__top-heading">Queries</h1>
                        </div>
                        


                        <TabsContainer>
                            <Tab
                                active={userQueries}
                                onClick={() => handleSubNavClick("userQueries")}
                            >
                                User queries
                            </Tab>
                            <Tab
                                active={venueQueries}
                                onClick={() => handleSubNavClick("venueQueries")}
                            >
                                Venue queries
                            </Tab>
                        </TabsContainer>

                        {userQueries ? (
                            <UserQueries />
                        ) : (
                            <VenueQueries />
                        )}
                    </section>
                </article>
            </div>
        </main>
    );
};

export default Queries;
